module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.defClass
  }, [_c('ul', {
    staticClass: "layui-tab-title site-demo-title",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        'layui-this': _vm.currentTab == item.Name
      },
      attrs: {
        "tabCode": item.Name
      },
      domProps: {
        "textContent": _vm._s(item.Title)
      },
      on: {
        "click": function($event) {
          _vm.current(item)
        }
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "layui-tab-content"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "layui-tab-item",
      class: {
        'layui-show': _vm.currentTab == item.Name
      }
    }, [_vm._t(item.Name)], 2)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-985df3aa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/YmTab.vue
// module id = 605
// module chunks = 2